<div class="layout-breadcrumb-container flex justify-content-between align-items-center shadow-1 sticky z-1 surface-0" style="top: 60px">
    <p-breadcrumb [model]="items" [home]="home" styleClass="layout-breadcrumb pl-3 py-2"></p-breadcrumb>
    <div class="layout-breadcrumb-buttons flex align-items-center pr-3">
        <button pButton pRipple type="button" icon="pi pi-cloud-upload" class="p-button-rounded p-button-text p-button-plain mr-1"></button>
        <button pButton pRipple type="button" icon="pi pi-bookmark" class="p-button-rounded p-button-text p-button-plain mr-1"></button>
        <button pButton pRipple type="button" icon="pi pi-power-off" class="p-button-rounded p-button-text p-button-plain mr-1"></button>
    </div>
</div>
